var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPage1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.64301 6.74906C1.29999 5.47042 1.46767 3.29075 3.14453 2.23663C4.36428 1.46973 6.00285 1.7001 7.03653 2.68423L7.51585 3.14058C7.81523 3.42561 8.29992 3.42561 8.59854 3.14058C8.89792 2.85627 8.89792 2.39482 8.59854 2.10978L8.19349 1.72415C6.41479 0.0307058 3.49292 -0.141338 1.66139 1.50035C-0.233691 3.19962 -0.267379 6.04049 1.56032 7.77986L2.10166 8.29526C2.40028 8.58029 2.88573 8.58029 3.18435 8.29526C3.48373 8.01095 3.48373 7.5495 3.18435 7.26446L2.64301 6.74906ZM13.7692 7.03266L13.3787 6.66087C13.0794 6.37583 12.5947 6.37583 12.296 6.66087C11.9967 6.94518 11.9967 7.40663 12.296 7.69167L12.7754 8.14801C13.809 9.13215 14.0503 10.6922 13.2455 11.8535C12.1383 13.4499 9.84815 13.6089 8.50589 12.3309L7.96454 11.8156C7.66516 11.5305 7.18049 11.5305 6.88187 11.8156C6.58248 12.0999 6.58248 12.5613 6.88187 12.8463L7.42321 13.3617C9.24555 15.0967 12.2187 15.0698 14.0043 13.2794C15.7447 11.5349 15.5564 8.73412 13.7692 7.03266ZM10.6713 11.3002L3.72569 4.68749C3.42707 4.40246 3.42707 3.94101 3.72569 3.65598C4.02507 3.37167 4.50975 3.37167 4.80837 3.65598L11.7547 10.2686C12.0533 10.5537 12.0533 11.0151 11.7547 11.3002C11.4553 11.5845 10.9707 11.5845 10.6713 11.3002Z",
    fill: "#A100FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage1);
export default __webpack_public_path__ + "static/media/Page-1.8ae9ac0da32dc7d82e2fd2f3caf2cd24.svg";
export { ForwardRef as ReactComponent };